import { Collapse, Form, Input } from "antd";
import { useIntl } from "react-intl";

const { Panel } = Collapse;

interface BotMessageFormProp {
  isDepositSelected?: boolean;
  isCheckBalanceSelected?: boolean;
  isWithdrawSelected?: boolean;
  isChatWithAgentSelected?: boolean;
}

const BotMessageForm = ({
  isDepositSelected,
  isCheckBalanceSelected,
  isWithdrawSelected,
  isChatWithAgentSelected,
}: BotMessageFormProp) => {
  const { messages } = useIntl();

  return (
    <Collapse defaultActiveKey={["1", "2", "3", "4", "5"]}>
      {isCheckBalanceSelected && (
        <Panel
          header={messages["TELEGRAM.CHECK_BALANCE_INFORMATION"] as string}
          key="1"
        >
          <Form.Item
            name={["extraData", "BOT_MESSAGE", "checkBalanceMessage"]}
            style={{ marginBottom: "4px" }}
            label={messages["TELEGRAM.BALANCE_MESSAGE"] as string}
            // rules={[RULES.required]}
            tooltip={messages["TELEGRAM.CHECK_BALANCE_MESSAGE"] as string}
          >
            <Input.TextArea autoSize={{ minRows: 2, maxRows: 5 }} />
          </Form.Item>
        </Panel>
      )}
      {isDepositSelected && (
        <Panel
          header={messages["TELEGRAM.DEPOSIT_INFORMATION"] as string}
          key="2"
        >
          <Form.Item
            name={["extraData", "BOT_MESSAGE", "currencyMessage"]}
            style={{ marginBottom: "4px" }}
            label={messages["TELEGRAM.CURRENCY_MESSAGE"] as string}
            // rules={[RULES.required]}
            tooltip={messages["TELEGRAM.CURRENCY_TOOLTIP"] as string}
          >
            <Input
              placeholder={messages["TELEGRAM.CURRENCY_PLACEHOLDER"] as string}
            />
          </Form.Item>
          <Form.Item
            name={["extraData", "BOT_MESSAGE", "amountLabel"]}
            style={{ marginBottom: "4px" }}
            label={messages["TELEGRAM.AMOUNT_LABEL_MESSAGE"] as string}
            // rules={[RULES.required]}
            tooltip={messages["TELEGRAM.AMOUNT_LABEL_TOOLTIP"] as string}
          >
            <Input placeholder={messages["common.amount"] as string} />
          </Form.Item>
          <Form.Item
            name={["extraData", "BOT_MESSAGE", "invoiceLabel"]}
            style={{ marginBottom: "4px" }}
            label={messages["TELEGRAM.INVOICE_MESSAGE"] as string}
            // rules={[RULES.required]}
            tooltip={messages["TELEGRAM.INVOICE_TOOLTIP"] as string}
          >
            <Input
              placeholder={messages["TELEGRAM.INVOICE_PLACEHOLDER"] as string}
            />
          </Form.Item>
          <Form.Item
            name={["extraData", "BOT_MESSAGE", "successMessage"]}
            style={{ marginBottom: "4px" }}
            label={messages["TELEGRAM.SUCCESSFUL_MESSAGE"] as string}
            // rules={[RULES.required]}
            tooltip={messages["TELEGRAM.SUCCESSFUL_TOOLTIP"] as string}
          >
            <Input
              placeholder={
                messages["TELEGRAM.SUCCESSFUL_PLACEHOLDER"] as string
              }
            />
          </Form.Item>
          <Form.Item
            name={["extraData", "BOT_MESSAGE", "depositMessage"]}
            style={{ marginBottom: "4px" }}
            label={messages["TELEGRAM.DEPOSIT_MESSAGE"] as string}
            // rules={[RULES.required]}
            tooltip={messages["TELEGRAM.DEPOSIT_TOOLTIP"] as string}
          >
            <Input
              placeholder={messages["TELEGRAM.DEPOSIT_PLACEHOLDER"] as string}
            />
          </Form.Item>
          <Form.Item
            name={["extraData", "BOT_MESSAGE", "amountMessage"]}
            style={{ marginBottom: "4px" }}
            label={messages["TELEGRAM.AMOUNT_MESSAGE"] as string}
            // rules={[RULES.required]}
            tooltip={messages["TELEGRAM.AMOUNT_TOOLTIP"] as string}
          >
            <Input
              placeholder={messages["TELEGRAM.AMOUNT_PLACEHOLDER"] as string}
            />
          </Form.Item>
          <Form.Item
            name={["extraData", "BOT_MESSAGE", "invalidMessage"]}
            style={{ marginBottom: "4px" }}
            label={messages["TELEGRAM.INVALID_AMOUNT_MESSAGE"] as string}
            // rules={[RULES.required]}
            tooltip={messages["TELEGRAM.INVALID_AMOUNT_TOOLTIP"] as string}
          >
            <Input
              placeholder={
                messages["TELEGRAM.INVALID_AMOUNT_PLACEHOLDER"] as string
              }
            />
          </Form.Item>
          <Form.Item
            name={["extraData", "BOT_MESSAGE", "amountThreshold"]}
            style={{ marginBottom: "4px" }}
            label={messages["TELEGRAM.AMOUNT_THRESHOLD_MESSAGE"] as string}
            // rules={[RULES.required]}
            tooltip={messages["TELEGRAM.AMOUNT_THRESHOLD_TOOLTIP"] as string}
          >
            <Input
              placeholder={
                messages["TELEGRAM.AMOUNT_THRESHOLD_MESSAGE"] as string
              }
              type="number"
            />
          </Form.Item>
        </Panel>
      )}
      {isWithdrawSelected && (
        <Panel
          header={messages["TELEGRAM.WITHDRAWAL_INFORMATION"] as string}
          key="3"
        >
          <Form.Item
            name={["extraData", "BOT_MESSAGE", "withdrawSourceLabels", 0]}
            style={{ marginBottom: "4px" }}
            label={messages["TELEGRAM.WITHDRAW_BANK_ACCOUNT_LABEL"] as string}
            // rules={[RULES.required]}
            tooltip={
              messages["TELEGRAM.WITHDRAW_BANK_ACCOUNT_TOOLTIP"] as string
            }
          >
            <Input
              placeholder={
                messages["TELEGRAM.WITHDRAW_BANK_ACCOUNT_PLACEHOLDER"] as string
              }
            />
          </Form.Item>
          <Form.Item
            name={["extraData", "BOT_MESSAGE", "withdrawSourceLabels", 1]}
            style={{ marginBottom: "4px" }}
            label={messages["TELEGRAM.WITHDRAW_CRYPTO_LABEL"] as string}
            // rules={[RULES.required]}
            tooltip={messages["TELEGRAM.WITHDRAW_CRYPTO_TOOLTIP"] as string}
          >
            <Input
              placeholder={
                messages["TELEGRAM.WITHDRAW_CRYPTO_PLACEHOLDER"] as string
              }
            />
          </Form.Item>
          <Form.Item
            name={["extraData", "BOT_MESSAGE", "withdrawSourceMessage"]}
            style={{ marginBottom: "4px" }}
            label={messages["TELEGRAM.WITHDRAW_SOURCE_MESSAGE"] as string}
            // rules={[RULES.required]}
            tooltip={messages["TELEGRAM.WITHDRAW_SOURCE_TOOLTIP"] as string}
          >
            <Input
              placeholder={
                messages["TELEGRAM.WITHDRAW_SOURCE_PLACEHOLDER"] as string
              }
            />
          </Form.Item>
          <Form.Item
            name={["extraData", "BOT_MESSAGE", "withdrawAccountsMessage"]}
            style={{ marginBottom: "4px" }}
            label={messages["TELEGRAM.WITHDRAW_ACCOUNT_MESSAGE"] as string}
            // rules={[RULES.required]}
            tooltip={messages["TELEGRAM.WITHDRAW_ACCOUNT_TOOLTIP"] as string}
          >
            <Input
              placeholder={
                messages["TELEGRAM.WITHDRAW_ACCOUNT_PLACEHOLDER"] as string
              }
            />
          </Form.Item>
          <Form.Item
            name={[
              "extraData",
              "BOT_MESSAGE",
              "withdrawTransactionExistMessage",
            ]}
            style={{ marginBottom: "4px" }}
            label={messages["TELEGRAM.WITHDRAW_PENDING_MESSAGE"] as string}
            // rules={[RULES.required]}
            tooltip={messages["TELEGRAM.WITHDRAW_PENDING_TOOLTIP"] as string}
          >
            <Input
              placeholder={
                messages["TELEGRAM.WITHDRAW_PENDING_PLACEHOLDER"] as string
              }
            />
          </Form.Item>
          <Form.Item
            name={["extraData", "BOT_MESSAGE", "withdrawSuccessMessage"]}
            style={{ marginBottom: "4px" }}
            label={messages["TELEGRAM.WITHDRAW_SUCCESS_MESSAGE"] as string}
            // rules={[RULES.required]}
            tooltip={messages["TELEGRAM.WITHDRAW_SUCCESS_TOOLTIP"] as string}
          >
            <Input
              placeholder={
                messages["TELEGRAM.WITHDRAW_SUCCESS_PLACEHOLDER"] as string
              }
            />
          </Form.Item>
          {!isDepositSelected && (
            <>
              <Form.Item
                name={["extraData", "BOT_MESSAGE", "depositMessage"]}
                style={{ marginBottom: "4px" }}
                label={messages["TELEGRAM.DEPOSIT_MESSAGE"] as string}
                // rules={[RULES.required]}
                tooltip={messages["TELEGRAM.DEPOSIT_TOOLTIP"] as string}
              >
                <Input
                  placeholder={
                    messages["TELEGRAM.DEPOSIT_PLACEHOLDER"] as string
                  }
                />
              </Form.Item>
              <Form.Item
                name={["extraData", "BOT_MESSAGE", "amountMessage"]}
                style={{ marginBottom: "4px" }}
                label={messages["TELEGRAM.AMOUNT_MESSAGE"] as string}
                // rules={[RULES.required]}
                tooltip={messages["TELEGRAM.AMOUNT_TOOLTIP"] as string}
              >
                <Input
                  placeholder={
                    messages["TELEGRAM.AMOUNT_PLACEHOLDER"] as string
                  }
                />
              </Form.Item>
              <Form.Item
                name={["extraData", "BOT_MESSAGE", "invalidMessage"]}
                style={{ marginBottom: "4px" }}
                label={messages["TELEGRAM.INVALID_AMOUNT_MESSAGE"] as string}
                // rules={[RULES.required]}
                tooltip={messages["TELEGRAM.INVALID_AMOUNT_TOOLTIP"] as string}
              >
                <Input
                  placeholder={
                    messages["TELEGRAM.INVALID_AMOUNT_PLACEHOLDER"] as string
                  }
                />
              </Form.Item>
              <Form.Item
                name={["extraData", "BOT_MESSAGE", "amountThreshold"]}
                style={{ marginBottom: "4px" }}
                label={messages["TELEGRAM.AMOUNT_THRESHOLD_MESSAGE"] as string}
                // rules={[RULES.required]}
                tooltip={
                  messages["TELEGRAM.AMOUNT_THRESHOLD_TOOLTIP"] as string
                }
              >
                <Input
                  placeholder={
                    messages["TELEGRAM.AMOUNT_THRESHOLD_MESSAGE"] as string
                  }
                  type="number"
                />
              </Form.Item>
            </>
          )}
        </Panel>
      )}
      {isChatWithAgentSelected && (
        <Panel header={messages["TELEGRAM.CHAT_INFORMATION"] as string} key="4">
          <Form.Item
            name={["extraData", "BOT_MESSAGE", "chatRequestMessage"]}
            style={{ marginBottom: "4px" }}
            label={messages["TELEGRAM.CHAT_REQUEST_MESSAGE"] as string}
            // rules={[RULES.required]}
            tooltip={messages["TELEGRAM.CHAT_REQUEST_TOOLTIP"] as string}
          >
            <Input
              placeholder={
                messages["TELEGRAM.CHAT_REQUEST_PLACEHOLDER"] as string
              }
            />
          </Form.Item>
          <Form.Item
            name={["extraData", "BOT_MESSAGE", "chatSessionStartedMessage"]}
            style={{ marginBottom: "4px" }}
            label={messages["TELEGRAM.CHAT_SESSION_STARTED_MESSAGE"] as string}
            // rules={[RULES.required]}
            tooltip={
              messages["TELEGRAM.CHAT_SESSION_STARTED_TOOLTIP"] as string
            }
          >
            <Input
              placeholder={
                messages["TELEGRAM.CHAT_SESSION_STARTED_PLACEHOLDER"] as string
              }
            />
          </Form.Item>
          <Form.Item
            name={["extraData", "BOT_MESSAGE", "chatSessionEndedMessage"]}
            style={{ marginBottom: "4px" }}
            label={messages["TELEGRAM.CHAT_SESSION_ENDED_MESSAGE"] as string}
            // rules={[RULES.required]}
            tooltip={messages["TELEGRAM.CHAT_SESSION_ENDED_TOOLTIP"] as string}
          >
            <Input
              placeholder={
                messages["TELEGRAM.CHAT_SESSION_ENDED_PLACEHOLDER"] as string
              }
            />
          </Form.Item>
          <Form.Item
            name={["extraData", "BOT_MESSAGE", "chatUserEndedSessionMessage"]}
            style={{ marginBottom: "4px" }}
            label={
              messages["TELEGRAM.CHAT_USER_ENDS_SESSION_MESSAGE"] as string
            }
            // rules={[RULES.required]}
            tooltip={
              messages["TELEGRAM.CHAT_USER_ENDS_SESSION_TOOLTIP"] as string
            }
          >
            <Input
              placeholder={
                messages[
                  "TELEGRAM.CHAT_USER_ENDS_SESSION_PLACEHOLDER"
                ] as string
              }
            />
          </Form.Item>
        </Panel>
      )}
      {(isDepositSelected ||
        isCheckBalanceSelected ||
        isWithdrawSelected ||
        isChatWithAgentSelected) && (
        <Panel header={messages["TELEGRAM.BACK_INFORMATION"] as string} key="5">
          <Form.Item
            name={["extraData", "BOT_MESSAGE", "backLabel"]}
            style={{ marginBottom: "4px" }}
            label={messages["TELEGRAM.BACK_LABEL"] as string}
            // rules={[RULES.required]}
            tooltip={messages["TELEGRAM.BACK_LABEL_MESSAGE"] as string}
          >
            <Input placeholder={`<< ${messages["common.back"]}`} />
          </Form.Item>
        </Panel>
      )}
    </Collapse>
  );
};

export default BotMessageForm;
